import React, { PropsWithChildren } from "react";
import { CommonCheckbox, CheckboxWrapper, ContainedCheckbox } from "./atom";

export function Checkbox({
  children,
  gap = 10,
  type = "checkbox",
  checkboxType = "common",
  onChange = () => {},
  checked,
  value,
  disabled,
  hidden,
  indeterminate,
  ...props
}: CheckboxProps) {
  const StyledCheckbox = {
    common: CommonCheckbox,
    contained: ContainedCheckbox,
  }[checkboxType];
  return (
    <CheckboxWrapper
      hidden={hidden}
      gap={gap}
      disabled={disabled}
      onClick={(event) => {
        if (disabled) return;
        event.target.checked = !checked;
        onChange(event);
      }}
      className="checkbox-wrapper"
    >
      <StyledCheckbox
        type={type}
        checked={checked || false}
        onChange={() => void 0}
        disable={disabled}
        indeterminate={indeterminate}
        {...props}
      />
      <div className="border-box">
        <span />
      </div>
      <div className="checkbox-label">{children}</div>
    </CheckboxWrapper>
  );
}

export type CheckboxType = "common" | "contained";

export type CheckboxProps = PropsWithChildren<
  {
    gap?: number;
    checkboxType?: `${CheckboxType}`;
    hidden?: boolean;
    indeterminate?: boolean;
  } & React.InputHTMLAttributes<HTMLInputElement>
>;
